module.exports = __webpack_public_path__ + "media/newstyle/images/icon-book-orange-b6b9e34719b07ef644426ff82860daf0.svg";